import { useState } from 'react'

/**
 * Hook for managing authentication modal state
 */
export function useAuthModal() {
  const [showAuthModal, setShowAuthModal] = useState(false)

  const openAuthModal = () => setShowAuthModal(true)
  const closeAuthModal = () => setShowAuthModal(false)

  return {
    showAuthModal,
    setShowAuthModal,
    openAuthModal,
    closeAuthModal,
  }
}
